function parseTagName(text) {
  let retObj;

  if (text) {
    const [name, ...rest] = text.split(/([#.])/g);
    retObj = {
      name,
    };

    if (rest.length) {
      for (let i = 0, l = rest.length; i < l; i += 2) {
        switch (rest[i]) {
          case '#':
            retObj.id = rest[i + 1];
            break;
          case '.':
            retObj.className = `${retObj.className ? `${retObj.className} ` : ''}${rest[i + 1]}`;
            break;
          default:
            break;
        }
      }
    }
  }

  return retObj;
}

function element(tagName, attrs /* Object */, children) {
  if (arguments.length === 2) {
    const arg1 = arguments[1]; // eslint-disable-line prefer-rest-params
    if (Array.isArray(arg1) || arg1 instanceof HTMLElement || typeof arg1 === 'string') {
      children = attrs; // eslint-disable-line no-param-reassign
      attrs = null; // eslint-disable-line no-param-reassign
    }
  }

  const { name, id, className } = parseTagName(tagName);
  const tag = document.createElement(name);

  if (id) {
    tag.setAttribute('id', id);
  }

  if (className) {
    tag.setAttribute('class', className);
  }

  if (attrs) {
    Object.entries(attrs).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
  }

  if (children) {
    if (Array.isArray(children)) {
      tag.append(...children);
    } else {
      tag.append(children);
    }
  }

  return tag;
}

export { element, parseTagName };
